module.exports = __webpack_public_path__ + "static/media/stoveThreeFourthsOut.fa516ba0.gif";